import React, { useState } from "react";
import { IconButton } from "@mui/material";
import { ArrowBack, ArrowForward } from "@mui/icons-material";

export default function PaginatedReport({
  data,
  rowsPerPage = 10,
  renderTable,
}) {
  const [currentPage, setCurrentPage] = useState(1);

  const startIndex = (currentPage - 1) * rowsPerPage;
  const paginatedData = data.slice(startIndex, startIndex + rowsPerPage);

  const totalPages = Math.ceil(data.length / rowsPerPage);

  return (
    <>
      {renderTable(paginatedData)}
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          marginTop: "10px",
          borderRadius: "8px",
        }}
      >
        <IconButton
          onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
          disabled={currentPage === 1}
          style={{
            color: currentPage === 1 ? "#ccc" : "#1976d2",
            transition: "color 0.3s",
          }}
        >
          <ArrowBack />
        </IconButton>
        <span
          style={{
            margin: "0 15px",
            fontSize: "16px",
            fontWeight: "bold",
            color: "#333",
          }}
        >
          {currentPage} / {totalPages}
        </span>
        <IconButton
          onClick={() =>
            setCurrentPage((prev) => Math.min(prev + 1, totalPages))
          }
          disabled={currentPage === totalPages}
          style={{
            color: currentPage === totalPages ? "#ccc" : "#1976d2",
            transition: "color 0.3s",
          }}
        >
          <ArrowForward />
        </IconButton>
      </div>
    </>
  );
}
